import React from 'react'
import './Competences.css'
import { useTranslation } from 'react-i18next'

const Competences = () => {
  const { t } = useTranslation();
  
  return (
    <section id='competences' className="content_section">
      <div className="content_section_inner">
        <h2>{t('skills.title')}</h2>
        <div className='container'>
          <div className='col col-2-6'>
            <div className='competence-item'>
              <h4>{t('skills.categories.frontend')}</h4>
              <ul className='double'>
                <li>HTML 5</li>
                <li>CSS 3</li>
                <li>JavaScript</li>
                <li>JQuery</li>
                <li>React JS</li>
                <li>Gatsby</li>
                <li>DOM</li>
                <li>SASS</li>
                <li>Responsive</li>
                <li>Bootstrap</li>
                <li>SEO</li>
                <li>UI / UX</li>
                <li>Next JS</li>
              </ul>
            </div>
          </div>
          <div className='col col-1-6'>
            <div className='competence-item'>
              <h4>{t('skills.categories.applications')}</h4>
              <ul className='simple'>
                <li>React Native</li>
                <li>PWA</li>
                <li>Expo</li>
                <li>Flutter</li>
              </ul>
            </div>
          </div>
          <div className='col col-1-6'>
            <div className='competence-item'>
              <h4>{t('skills.categories.backend')}</h4>
              <ul className='simple'>
                <li>PHP</li>
                <li>Node JS</li>
                <li>Express</li>
                <li>Python</li>
              </ul>
            </div>
          </div>
          <div className='col col-1-6'>
            <div className='competence-item'>
              <h4>{t('skills.categories.database')}</h4>
              <ul className='simple'>
                <li>MySQL</li>
                <li>Mongo DB</li>
                <li>SQ Lite</li>
              </ul>
            </div>
          </div>
          <div className='col col-1-6'>
            <div className='competence-item'>
              <h4>{t('skills.categories.cms')}</h4>
              <ul className='simple'>
                <li>WordPress</li>
                <li>Prestashop</li>
                <li>WooCommerce</li>
                <li>Drupal</li>
                <li>Django</li>
                <li>Elementor</li>
              </ul>
            </div>
          </div>
          <div className='col col-2-6'>
            <div className='competence-item'>
              <h4>{t('skills.categories.graphics')}</h4>
              <ul className='double'>
                <li>Photoshop</li>
                <li>Illustrator</li>
                <li>InDesign</li>
                <li>Publisher</li>
                <li>Infinity Designer</li>
                <li>Sketch</li>
                <li>Figma</li>
                <li>XD</li>
                <li>Publisher</li>
                <li>Canvas</li>
                <li>Identité visuelle</li>
              </ul>
            </div>
          </div>
          <div className='col col-1-6'>
            <div className='competence-item'>
              <h4>{t('skills.categories.server')}</h4>
              <ul className='simple'>
                <li>FTP</li>
                <li>SSH</li>
                <li>PHPMyAdmin</li>
                <li>SSL</li>
                <li>DNS</li>
                <li>Emails</li>
              </ul>
            </div>
          </div>
          <div className='col col-1-6'>
            <div className='competence-item'>
              <h4>{t('skills.categories.deployment')}</h4>
              <ul className='simple'>
                <li>Vercel</li>
                <li>Heroku</li>
                <li>Netlify</li>
              </ul>
            </div>
          </div>
          <div className='col col-1-6'>
            <div className='competence-item'>
              <h4>{t('skills.categories.other')}</h4>
              <ul className='simple'>
                <li>Contentfull</li>
                <li>Strapi</li>
                <li>Make</li>
                <li>Zapier</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
} 

export default Competences